































import {
	computed,
	defineComponent,
	PropType,
} from '@vue/composition-api';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import { Routes } from '@front-app/constants/routes';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import MembersList from '@front-app/views/home/group/admin/memberManagement/MembersList.vue';
import { MemberSort } from '@front-app/modules/groupMember/hooks/useSortMemberRadio';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { GroupsStore } from '@front-app/store/singletons/Groups';

export default defineComponent({
	components: {
		ColumnHeader,
		ErrorCard,
		MembersList,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		roleFilter: {
			type: String as PropType<UserRole>,
			default: UserRole.MEMBER,
		},
		sortBy: {
			type: String as PropType<MemberSort>,
			default: MemberSort.ALPHABETICAL,
		},
	},
	setup(props) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasMemberManagementAccess } = useAdminAccess(group);

		return {
			hasMemberManagementAccess,
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
		};
	},
});
